/* ==========================================================================
   AZURE GLASSES — Página de colección
   Drawer de filtros + orden automático. Sin dependencias.
   Reutiliza el mismo bloqueo de scroll (.is-locked) que azure-v2.js.
   ========================================================================== */

(function () {
  'use strict';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  var scrollY = 0;

  function lockScroll() {
    if (document.body.classList.contains('is-locked')) return;
    scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = -scrollY + 'px';
    document.body.style.width = '100%';
    document.body.classList.add('is-locked');
  }

  function unlockScroll() {
    if (!document.body.classList.contains('is-locked')) return;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.classList.remove('is-locked');
    window.scrollTo(0, scrollY);
  }

  function trapFocus(container, e) {
    var items = $$('a[href], button:not([disabled]), input:not([disabled]), select, [tabindex]:not([tabindex="-1"])', container)
      .filter(function (el) { return el.offsetParent !== null; });
    if (!items.length) return;

    var first = items[0];
    var last = items[items.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function initCollection() {
    var drawer = $('[data-azc-drawer]');
    if (!drawer) return;

    var openers = $$('[data-azc-filter-open]');
    var closers = $$('[data-azc-filter-close]', drawer);
    var lastFocused = null;

    function open() {
      lastFocused = document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      lockScroll();

      window.setTimeout(function () {
        var target = $('select, input, button', drawer);
        if (target) target.focus();
      }, 60);
    }

    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      unlockScroll();
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }

    openers.forEach(function (b) { b.addEventListener('click', open); });
    closers.forEach(function (b) { b.addEventListener('click', close); });

    document.addEventListener('keydown', function (e) {
      if (!drawer.classList.contains('is-open')) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'Tab') trapFocus(drawer, e);
    });

    /* Orden en la barra: aplicar al cambiar, sin botón */
    var sortForm = $('[data-azc-sort-form]');
    if (sortForm) {
      var sortSelect = $('select[name="sort_by"]', sortForm);
      if (sortSelect) {
        sortSelect.addEventListener('change', function () { sortForm.submit(); });
      }
    }

    /* Limpia campos de precio vacíos para no ensuciar la URL */
    var filterForm = $('[data-azc-filter-form]', drawer);
    if (filterForm) {
      filterForm.addEventListener('submit', function () {
        $$('input[type="number"]', filterForm).forEach(function (input) {
          if (input.value === '') input.disabled = true;
        });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollection);
  } else {
    initCollection();
  }
})();
